import React from 'react'
import AgTechDataActionSurface from '@agtech/core/data/actions/AgTechDataActionSurfaces';
import { useOperationDataSetOperationLogoAction } from '@agtech/data/operations/OperationDataActions';
import { OperationLogoProvider } from '@agtech/data/operations/OperationDataQueries';
import AgTechFadeInView from '../../../../components/Pages/Loading/AgTechFadeInView';
import OperationUploadLogoButton from '../buttons/OperationUploadLogoButton';

export type LogoUpdateFormProps = {
    classes?: string,
    onLogoSubmitted?: () => Promise<void>
}

const LogoUpdateForm = (props: LogoUpdateFormProps) => {
    let updateOperationLogoAction = useOperationDataSetOperationLogoAction();

    return (
        <AgTechDataActionSurface
            action={updateOperationLogoAction}
            classes={props.classes}
            behavior={{
                returnToOpenStateOnCompletion: true,
                eventHandlers: {
                    onExecutionCompleted: props.onLogoSubmitted
                }
            }}
        >
            {(executor) => (
                <OperationLogoProvider>
                    {(operationLogo) => (
                        <div className='row-based stretched container'>
                            <div id='settings-logo-area' className='flexed centered container'>
                                {operationLogo ? (
                                    <div className='row-based rounded container' >
                                        <AgTechFadeInView>
                                            <img
                                                title="Operation Logo"
                                                src={`data:;base64,${operationLogo}`}
                                                className='mb-4'
                                                style={{ height: 280, width: 420 }}
                                            />
                                        </AgTechFadeInView>
                                        <div className='wide row-based-horizontally-centered container'>
                                            <div id='settings-logo-upload'>
                                            <OperationUploadLogoButton
                                                text='Upload new logo'
                                                classes='button-highlight mt-6 py-2 centered flex'
                                                styles={{ width: 180 }}
                                                onLogoUpdated={async logo => {
                                                    await executor.executeAction(updateOperationLogoAction, {
                                                        submittedEntity: logo
                                                    });
                                                }}
                                            />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='row-based bordered rounded container' style={{ height: 280, width: 420 }}>
                                        <div id='settings-logo-upload'>
                                        <OperationUploadLogoButton
                                            text='Upload logo'
                                            classes='button-highlight'
                                            styles={{ width: 180 }}
                                            onLogoUpdated={async logo => {
                                                await executor.executeAction(updateOperationLogoAction, {
                                                    submittedEntity: logo
                                                });
                                            }}
                                        />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </OperationLogoProvider>
            )}
        </AgTechDataActionSurface>
    )
}

export default LogoUpdateForm